// Sync-required: matching backend file at
// quotebid-backend/src/tierLimits.ts.
// If you change either file, change both.
//
// Per-tier footprint limits (service categories x launch cities),
// enforced server-side at signup, checkout, and both Settings edit
// endpoints (F1-F3). The absolute UI ceiling is still
// MAX_CATEGORIES_PER_BUSINESS (15) and the open-metro city list.
//
// Grandfather rule (server-enforced, mirrored in Settings UI):
// accounts above their plan limit keep and may SWAP within their
// current count, but cannot grow —
// effective limit = max(plan limit, current count).

export type TierId = 'starter' | 'pro' | 'premium';

export interface TierFootprintLimits {
  maxCategories: number;
  maxCities: number;
}

export const TIER_LIMITS: Record<TierId, TierFootprintLimits> = {
  starter: { maxCategories: 2, maxCities: 3 },
  pro: { maxCategories: 5, maxCities: 10 },
  premium: { maxCategories: 10, maxCities: 15 },
};

export const TIER_NAMES: Record<TierId, string> = {
  starter: 'Starter',
  pro: 'Pro',
  premium: 'Premium',
};

export function isTierId(v: unknown): v is TierId {
  return v === 'starter' || v === 'pro' || v === 'premium';
}
